import Session from 'supertokens-web-js/recipe/session';
import AppConfig from "./AppConfig";
import { getCookie } from "./utils";

interface ApiCallOptions {
    method: string;
    headers: {
        'Content-Type': string;
    };
    credentials: RequestCredentials;
    body?: string;
}

const apiCall = async (url: string, data: any = null, method: string = 'POST') => {
    const headers = {
        'Content-Type': 'application/json',
    };

    const options: ApiCallOptions = {
        'method': method,
        headers,
        credentials: 'include',
    };

    if (data) {
        options.body = JSON.stringify(data);
    }

    try {
        const response = await fetch(`${AppConfig.DASHBOARD_V2_API_URL}${url}`, options);

        if (response.status === 401) {
            console.log('Unauthorized! Redirecting to login.');
            // Clear user session data
            const sAccessToken = getCookie('sAccessToken')
            const sFrontToken = getCookie('sFrontToken')

            if (sAccessToken == undefined && sFrontToken == undefined) {
                localStorage.clear();
                sessionStorage.clear();
                await Session.signOut();
                // Optionally, redirect to the login page
                window.location.href = `${AppConfig.DASHBOARD_V2_WEBSITE_DOMAIN}`;
                return null;
            }
        }

        if (!response.ok) {
            console.log(`HTTP error! status: ${response.status}`);
            return null;
        }

        const res = await response.text();
        return JSON.parse(res);
    } catch (error) {
        console.error('Error making API call:', error);
        return null;
    }
}

export default apiCall;
